module.exports = __webpack_public_path__ + "img/shock.0584d001.svg";